import { Notification } from "@vds/notifications";
import { Body, Title } from '@vds/typography';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { useGetDevicesAndPlansByNameQuery } from '../../features/devicesAndPlans/devicesAndPlansFetch';
import { GetFooterNotes, GetHelperText, GetPlanPageDetails, GetSelectedDeviceDetails } from "../../shared/components/GetPlanPageDetails.jsx";
import FullPageLoader from '../../shared/components/Loader';
import { getDestList, getDevicesPayload } from '../../shared/utils/globalUtils';
import { dispatchNotifyEvent, dispatchPageView } from '../../shared/utils/tagging';
import { convertStringToElements } from '@vds/html-parsers';
import { Button } from "@vds/buttons";
import { unauth, SessionIdGlobal, isDesktop, isTab, plansPageContinueButtonFFlag } from '../../shared/utils/globalConfig';
import { saveSelectedDeviceDetails,updateSelectedPlanData, saveSelectedDestinations } from '../../features/selectedData/selectedDataReducer';
import ErrorPage from '../../shared/components/ErrorPage';
import {saveConfirmedPlanData, savePersistantDestinations, savePersistantDates, setSessionIdVarUnauth, saveSelectedDeviceDetailsUnauth } from '../../features/selectedData/persistantDataReducer';
import xss from 'xss';
import PaygoButton from "../../shared/components/PaygoButton.jsx";
import PaygoNotification from "../../shared/components/PaygoNotification.jsx";
import RemovePlanNotification from "../../shared/components/RemovePlanNotification.jsx";

const PlanSelectionPageMain = styled.div`
`
const Space = styled.div`
padding-top: ${props => props.pt || 20}px;
`


const fetchValues = (sessionIdVarUnauth) => {
    if(unauth){
        
    return( (sessionIdVarUnauth === SessionIdGlobal)? false : true)}
       
   }
export default function PlanSelection() {

    
    const dispatch = useDispatch();
    const { selectedDestinations, selectedDates,selectedDeviceDetailsUnauth, sessionIdVarUnauth } = useSelector(state => state?.persistantReducer);
    const { selectedDeviceDetails } = useSelector(state => state?.selectedReducer);
    
    
    let isSesIdNotMatched =  false;
       isSesIdNotMatched = fetchValues(sessionIdVarUnauth);
       
       useEffect(() => {
           if (isSesIdNotMatched && unauth) {
               dispatch(saveConfirmedPlanData([]));
               dispatch(saveSelectedDestinations([]));
               dispatch(saveSelectedDeviceDetailsUnauth({}));
               dispatch(savePersistantDestinations([]));
               dispatch(savePersistantDates({}));
               dispatch(setSessionIdVarUnauth(""));
               window.location.href = xss('/digital/nsa/nos/ui/intl/trip/');
           }
       }, [])
   


    const getDevicesPayloadUnauth = () => {
        let payload = {
            'destinationSelected': getDestList(selectedDestinations, 'key'),
            "travelStartDate": selectedDates?.travelStartDate,
            "travelEndDate": selectedDates?.travelEndDate,
            "unAuthflow": true,
            "deviceNickName": selectedDeviceDetailsUnauth?.deviceDisplayName,
            "deviceImageUrl": selectedDeviceDetailsUnauth?.deviceImageUrl,
            "skuId": selectedDeviceDetailsUnauth?.skuId,
            "brandName": selectedDeviceDetailsUnauth?.brandName,
        }
        return payload;
    }
    const Payload = unauth ? getDevicesPayloadUnauth() : getDevicesPayload(selectedDates,selectedDestinations);
    const { data, isSuccess, isLoading, error } = useGetDevicesAndPlansByNameQuery(Payload,
    { skip: unauth && (Object.keys(selectedDeviceDetailsUnauth).length == 0 || selectedDestinations?.length === 0 || isSesIdNotMatched) })
   
    const [planPageDetails, setPlanDetails] = useState();
    const [devicesAndPlans, setDevicesAndPlans] = useState();


    //Redirect to destination, if destination and travel dates are empty
    let isEmptyRedirect =  Object.keys(unauth ? selectedDeviceDetailsUnauth : selectedDeviceDetails)?.length === 0 ;
    let isDestinationEmpty = selectedDestinations?.length === 0 || (selectedDates?.travelStartDate == undefined && selectedDates?.travelEndDate == undefined);
   
 
    const CanMexLength  = selectedDestinations?.filter((dest) => dest?.key === 'CAN' || dest?.key === 'MEX').length;
    const CruiseAirLength  = selectedDestinations?.filter((dest) => dest?.key === 'AAA' || dest?.key === 'CSP').length;
    const PaygoCountryLength  = selectedDestinations?.filter((dest) => dest?.paygoOnly === 'Y' && dest?.key != 'AAA' && dest?.key != 'CSP').length;
    const PaygoCruiseAirCanMexDest = (PaygoCountryLength + CruiseAirLength + CanMexLength == selectedDestinations?.length);


    useEffect(() => {
        if ( isEmptyRedirect || isDestinationEmpty ){
                if (unauth) {
                window.location.href = xss('/digital/nsa/nos/ui/intl/trip/');
            }
            else {
                window.location.href = xss('/digital/nsa/secure/ui/intl/trip/');
            } 
        }
    }, [unauth ? selectedDeviceDetailsUnauth : selectedDeviceDetails])

    useEffect(() => {
        setPlanDetails(data?.body?.data?.planDetailsLand);
        setDevicesAndPlans(data?.body?.data?.devicesAndPlans)
    }, [data]);

    //saveSelectedDeviceDetails from planpage response for unauth flow 
    //clear the confirmedplandata again if the user starts from landplan through back arrow
    useEffect(() => {
        if(unauth) 
           {
            dispatch(saveSelectedDeviceDetails(data?.body?.data?.devicesAndPlans?.deviceDetails[0])); 
            dispatch(saveConfirmedPlanData([]));
            dispatch(updateSelectedPlanData({}));
        } 
    }, [data]);

    
     

    useEffect(() => {

        if (selectedDeviceDetails?.availableCanMexCovered) {
            dispatchNotifyEvent(planPageDetails?.lineCoverage?.title, '', planPageDetails?.lineCoverage?.subtitle)
        }

    }, [])
    useEffect(() => {
        if (devicesAndPlans?.payGoOnly && devicesAndPlans?.payGoOnlyNotificationText) {
            dispatchNotifyEvent(devicesAndPlans?.payGoOnlyNotificationText, "99")
        }
        if (devicesAndPlans?.mixedPayGo && devicesAndPlans?.mixedPayGoNotificationText) {
            dispatchNotifyEvent(devicesAndPlans?.mixedPayGoNotificationText)
        }
    },[devicesAndPlans])
    //Tagging
    useEffect(() => {
        dispatchPageView('ITP_PlanSelection', 'review plan details','#plan_selection');
    }, [])

   // Prefetch images before setting the state
    const prefetchImages = (imageUrls) => {
        return Promise.all(
            imageUrls.map((url) => {
                return new Promise((resolve, reject) => {
                    const img = new Image();
                    img.src = url;
                    img.onload = resolve;
                    img.onerror = reject;
                });
            })
        );
    };
    useEffect(() => {
        if (window.reactGlobals?.featureFlag?.preFetchImgFixFFlag == "true") {
            if (data?.body?.data?.skipCruiseAndFlightPlans) {
                const skipPlans = data.body.data.skipCruiseAndFlightPlans;
                const imageUrls = skipPlans?.skipPlanObject?.map(plan => plan.imageurl);   
                prefetchImages(imageUrls).catch(() => {
                });
            }
        }
    }, [data]);

    const updatePaygoCallRate = (plan) => {
        const countryDetail = planPageDetails?.payGoRates?.countryDetails?.[0];
        if (!countryDetail?.call || !Array.isArray(plan.availableFeatures)) {
            
            return plan;
        }
        
        const updatedFeatures = plan.availableFeatures.map((feature) => {
            if (feature?.icon === 'cell-phone') {
                return {
                    ...feature,
                    text: countryDetail.call,
                    reviewText: countryDetail.call,
                };
            }
            return feature;
        });
        
        return {
            ...plan,
            availableFeatures: updatedFeatures
        };
    };

    const getJSONDetails = (obj) => {
        // Using structured clone for better performance and reliability

        if (typeof structuredClone === 'function') {
            return structuredClone(obj);
        }
        return JSON.parse(JSON.stringify(obj));
    };
    
    const getLandPlans = () => {
        let plans = [];
        let landplans = planPageDetails?.planInfo.map((plan) => {
            if (plan?.planTypeName === 'TRAVELPASS' && selectedDeviceDetails.travelPassPlan && plan?.planId === selectedDeviceDetails?.availableTravelpassId) {
                let travelPassUpdated = getJSONDetails(plan);
                travelPassUpdated['currentPlan'] = selectedDeviceDetails?.currentPlanAsTravelPass;
                plans.push(travelPassUpdated)
            }
            if (plan?.planTypeName === 'MONTHLY' && selectedDeviceDetails.monthlyPlan && selectedDeviceDetails.monthlyITPRecurring) {
                let monthlyUpdated = getJSONDetails(plan);
                monthlyUpdated['currentPlan'] = selectedDeviceDetails?.currentPlanAsMonthly;
                plans.push(monthlyUpdated)
            }
            if (plan?.planTypeName === 'MONTHLY_RECURRING' && !selectedDeviceDetails.monthlyPlan && selectedDeviceDetails.monthlyITPRecurring) {
                let monthlyUpdated = getJSONDetails(plan);
                monthlyUpdated['currentPlan'] = selectedDeviceDetails?.currentPlanAsMonthlyRecurring;
                plans.push(monthlyUpdated)
            }
            if (plan?.planTypeName === 'PAYGO_LAND' && selectedDeviceDetails.payAsYouGoLand) {
                let paygolandUpdated = getJSONDetails(plan);
                paygolandUpdated['currentPlan'] = selectedDeviceDetails?.currentPlanAsPaygoLand;

                if (selectedDestinations?.length === 1) {
                    paygolandUpdated = updatePaygoCallRate(paygolandUpdated);
                }

                plans.push(paygolandUpdated)
            }
        })
        return plans;
    }
    const isPayGoScenariosWithMonthly = !unauth && (selectedDeviceDetails?.currentPlanDetails?.filter((plan) => plan?.monthlyITP === true || plan?.monthlyITPRecurring === true).length > 0) && (devicesAndPlans?.payGoOnly || selectedDeviceDetails?.containsCanMexCruiseAirplaneDest  || PaygoCruiseAirCanMexDest);


    return (
        <PlanSelectionPageMain id="plan_selection">
            {(isSuccess && planPageDetails)
                ?
                <>
                    <GetSelectedDeviceDetails planType='land'/>
                    <Space />
                    <Title size="XLarge">{planPageDetails?.pageTitle}</Title>
                    <Space />
                    <Body size="large">{planPageDetails?.heading}</Body>
                    {planPageDetails?.discountedCustomer && <><Space /><Body size="large">{planPageDetails?.discountedPlans}</Body></>}
                    {selectedDeviceDetails?.availableCanMexCovered && <Notification
                        type="info"
                        title={planPageDetails?.lineCoverage?.title}
                        subtitle={planPageDetails?.lineCoverage?.subTitle}
                        fullBleed={false}
                        inline={false}
                        disableFocus={true}
                        hideCloseButton={true}
                    />}
                    {devicesAndPlans?.payGoOnly && devicesAndPlans?.payGoOnlyNotificationText &&
                        <Notification
                            type="error"
                            title={convertStringToElements(devicesAndPlans?.payGoOnlyNotificationText)}
                            fullBleed={false}
                            inline={false}
                            disableFocus={true}
                            hideCloseButton={true}
                        />}

                    {devicesAndPlans?.mixedPayGo && devicesAndPlans?.mixedPayGoNotificationText &&
                        <Notification
                            type="warning"
                            title={convertStringToElements(devicesAndPlans?.mixedPayGoNotificationText)}
                            fullBleed={false}
                            inline={false}
                            disableFocus={true}
                            hideCloseButton={true}
                         />}
                    
                    <RemovePlanNotification
                        selectedDeviceDetails={selectedDeviceDetails}
                        devicesAndPlans={devicesAndPlans}
                        isPayGoScenariosWithMonthly={isPayGoScenariosWithMonthly}
                    />
                    <PaygoNotification
                        selectedDeviceDetails={selectedDeviceDetails}
                        devicesAndPlans={devicesAndPlans}
                    />
                    
                    <GetPlanPageDetails availablePlans={getLandPlans()} theme='monarch' planType={'land'}  isPayGoScenariosWithMonthly={isPayGoScenariosWithMonthly} />
                    <GetHelperText subHeadingText={planPageDetails?.subHeadingText} />
                    <Space pt={32}></Space>
                    <GetFooterNotes footerNotes={planPageDetails?.footerNotes} />
                   
                    <PaygoButton
                    isPayGoScenariosWithMonthly={isPayGoScenariosWithMonthly}
                    ctaLabel={planPageDetails?.continueText}
                    selectedDeviceDetails={selectedDeviceDetails}
                    />
                </>
                :
                (error && <ErrorPage errorDetails={error?.data} />)
            }
                {isLoading && <FullPageLoader />}
               
        </PlanSelectionPageMain>);
}